import React, { useEffect, useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useSelector } from "react-redux";
import { AccessibilityHidden } from '@skillz/accessibility';
import loadingImage from '../../../../../assests/loadImage.png'
import classes from './CoursePicture.module.css'

const CoursePicture = ({ picture, courseId, course }) => {

    const [myPicture, setMyPicture] = useState()
    const { domains, general } = useSelector(state => state.uiData);

    const isHTML = (value) => !(value || '').replace(/<([^>]+?)([^>]*?)>(.*?)<\/\1>/ig, '').replace(/(<([^>]+)>)/ig, '').trim();

    useEffect(() => {
        if (picture) 
            setMyPicture(picture)
        else if (course) {
            // אם יש לנו את הקורס המלא, נשתמש בו
            if (course.picture) {
                setMyPicture(course.picture)
            }
            else if (course.providerLogo) 
                setMyPicture(course.providerLogo)
            else {
                // נחפש תמונות ברירת מחדל לפי הדומיין של הקורס
                const domainPictures = domains?.find(domain => domain.name === course.domain)?.defaultImages;
                const defaultPictures = domainPictures || general?.defaultDomainsCoursePictures;

                if (defaultPictures && courseId) {
                    let total = 0;
                    ([...`${courseId}`]).forEach(p => {
                        if (/^[a-zA-Z]+$/.test(p))
                            total += p.toLowerCase().charCodeAt() - 96
                        else if (/^[1-9]$/.test(p))
                            total += Number(p)
                    })
                    setMyPicture(defaultPictures[Math.abs(total) % defaultPictures?.length])
                }
            }
        }
        else {
            // גיבוי - אם אין לנו קורס, ננסה למצוא לפי courseId
            if (general && courseId) {
                const defaultPictures = general?.defaultDomainsCoursePictures;
                if (defaultPictures) {
                    let total = 0;
                    ([...`${courseId}`]).forEach(p => {
                        if (/^[a-zA-Z]+$/.test(p))
                            total += p.toLowerCase().charCodeAt() - 96
                        else if (/^[1-9]$/.test(p))
                            total += Number(p)
                    })
                    setMyPicture(defaultPictures[Math.abs(total) % defaultPictures?.length])
                }
            }
        }
    }, [course, courseId, picture, domains, general])

    return (
        <AccessibilityHidden>
            {isHTML(myPicture) ?
                <div className={classes.PictureWrapper} dangerouslySetInnerHTML={{ __html: myPicture }}></div>
                :
                <LazyLoadImage
                    className={classes.ProviderImg}
                    alt=""
                    src={myPicture}
                    placeholderSrc={loadingImage}
                    width={"100%"}
                    height={"100%"}
                />
            }
        </AccessibilityHidden >
    )
}

export default CoursePicture